import React, { Fragment } from "react";
import { Layout } from "antd";

const { Footer } = Layout;

const AppFooter = () => {
  return (
    <Fragment>
      <Footer
        style={{
          textAlign: "center",
          padding: "5px 50px ",
        }}
      >
        Voo Chat ©{new Date().getFullYear()} All Rights Reserved.
      </Footer>
    </Fragment>
  );
};

export default AppFooter;
